import { render } from "./CurrentLivingCondition.vue?vue&type=template&id=13080a49"
import script from "./CurrentLivingCondition.vue?vue&type=script&lang=js"
export * from "./CurrentLivingCondition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__